import { z } from "zod";
import { BioContentSchema } from "./bio.schema";
import { GenderEnumSchema } from "./gender.schema";

/**
 * Public profile projection returned by Cloud Functions for peer reads.
 * Never includes date_of_birth, phone, likes, or other private fields.
 * Not `.strict()` — unknown keys are stripped so additive CF fields do not break older clients.
 */
export const PublicUserProfileSchema = z.object({
  uid: z.string().min(1),
  display_name: z.string().min(1),
  bio: z.string(),
  bioContent: BioContentSchema.optional(),
  photo_url: z.url(),
  age: z.number().int().nonnegative(),
  gender: GenderEnumSchema,
  desired_genders: z.array(GenderEnumSchema),
  lastKnownEventEnteredAt: z.string().nullable(),
});

export type PublicUserProfile = z.infer<typeof PublicUserProfileSchema>;
